import {Accordion, AccordionDetails, AccordionSummary, Box} from "@mui/material"
import React,{useState} from "react"
import ChevronCell from "./ChevronCell"
import Content from "../../../components/Content"

const escapeRegExp = (string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

const deepReplaceString = (data, targetString, replacementString) => {
  if (typeof data === 'string') {
    const regex = new RegExp(escapeRegExp(targetString), 'g');
    return data.replace(regex, replacementString);
  }

  if (typeof data !== 'object' || data === null) {
    return data;
  }

  if (Array.isArray(data)) {
    return data.map(item =>
      deepReplaceString(item, targetString, replacementString)
    );
  }

  const newObject = {};
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      newObject[key] = deepReplaceString(
        data[key],
        targetString,
        replacementString
      );
    }
  }

  return newObject;
}

const OFFSET = 1

const ContainerAccordionTableRow = ({
    container,
    gridTemplateColumns,
    contentWidgets,
    detailWidgets,
    row,
    rowKey,
}) => {
    const [open, setOpen] = useState(false)
    const renderContentWidgets = contentWidgets.map((widget) => {
        const renderWidget = _.cloneDeep(widget)
        if (widget.connections?.origin?.pointer) {
            renderWidget.connections.origin.pointer =
                renderWidget.connections?.origin.pointer.replace("[i]", rowKey)
            renderWidget.subtext = renderWidget.subtext?.replace("[i]", rowKey)
        }
        return renderWidget
    })

    const renderDetailWidgets = detailWidgets.map((widget) => {
        const renderWidget = _.cloneDeep(widget)
        return deepReplaceString(deepReplaceString(renderWidget, "[i]",rowKey), "[j]","[i]")
    })

    const toggleAccordion = () => {
        setOpen((prev) => !prev)
    }

    return (
        <Accordion
            key={rowKey}
            slotProps={{transition: {unmountOnExit: true}}}
            onClick={toggleAccordion}
            sx={{
                "&.MuiAccordion-root:before": {
                    display: "none",
                },
                borderRadius: 0,
                margin: "0 !important",
                borderBottom: "1px solid #ccc",
                borderTop: rowKey === 0 ? "1px solid #ccc" : "none",
                backgroundColor: "#ffffff"
            }}>
            <AccordionSummary
                component="div"
                role="button"
                tabIndex={0}
                aria-controls={`panel-${rowKey}-content`}
                id={`panel-${rowKey}-header`}
                sx={{
                    display: "grid",
                    gridTemplateColumns: gridTemplateColumns,
                    padding: 0,
                    minHeight: "48px",
                    "& .MuiAccordionSummary-content": {
                        margin: 0,
                        display: "contents",
                    },
                }}>
                <>
                    {renderContentWidgets?.map((widget) => (
                        <Box
                            bgcolor={widget.background && "#ddddff"}
                            sx={{
                                gridColumn:
                                    widget.x + OFFSET + " /span " + widget.w,
                                gridRow: 1 + " /span " + widget.h,
                            }}>
                            <Content
                                key={widget.i}
                                entryNumber={rowKey}
                                child={widget}
                                value={row[widget.property]}
                                payload={row}
                            />
                        </Box>
                    ))}
                    <ChevronCell
                        expanded={open}
                        row={row}
                    />
                </>
            </AccordionSummary>
            <AccordionDetails
                sx={{
                    display: "grid",
                    gridTemplateColumns: gridTemplateColumns,
                    padding: 0,
                    borderTop: "1px solid #898989",
                }}>
                <Box
                    sx={{
                        gridColumn: `1 / span 1`,
                        bgcolor: "#f5f5f5",
                    }}></Box>

                {renderDetailWidgets?.map((widget, index) => (
                    <Box
                        key={widget.id}
                        sx={{
                            gridColumn:
                                widget.x + OFFSET + " /span " + widget.w,
                            gridRow: index + " /span " + widget.h,
                        }}>
                        <Content child={widget} />
                    </Box>
                ))}
            </AccordionDetails>
        </Accordion>
    )
}

export default ContainerAccordionTableRow
